// File: frontend/src/pages/FaqPage.js
import React, { useState } from 'react';
import './FaqPage.css'; 

// Your list of questions and answers
const faqData = [
  {
    question: "What is a product mockup?",
    answer: "A product mockup is a realistic, high-quality image that shows your design on a physical product (like a t-shirt, mug, or social media post). It's a vital tool that lets you showcase your product to customers without needing to pay for expensive photography and manufacturing for every new design."
  },
  {
    question: "How can good mockups help my brand?",
    answer: "High-quality mockups build trust and increase sales. They help customers visualize the final product, making them more confident in their purchase. A professional, photorealistic mockup makes your brand look more legitimate and valuable than competitors who use flat, low-quality images."
  },
  {
    question: "How is this AI Mockup Generator different from a Photoshop template?",
    answer: "Speed and realism. A Photoshop template just places a flat image layer on top. FullMockup's AI intelligently analyzes the product's lighting, curves, and texture. It then realistically blends your design onto the product, complete with natural-looking shadows and fabric folds, all in a few seconds—no design skill required."
  },
  {
    question: "What kind of images should I upload for the best results?",
    answer: (
      <>
        <p>For the best results, you should:</p>
        <ul>
          <li><strong>For your Product:</strong> Use a clear, bright, and simple photo of the blank item (e.g., a person wearing a blank t-shirt).</li>
          <li><strong>For your Design:</strong> A high-resolution PNG file with a transparent background (like a logo) will always look the most professional. If your design has a solid background (like a white box), you can use our "Remove Background" feature to clean it up.</li>
        </ul>
      </>
    )
  },
  {
    question: "What resolution are the final images? Are they ready for e-commerce?",
    answer: "Yes, they are 100% e-commerce ready. Our app uses a two-step AI process: Enhance: We use a best AI model. The final file is large enough for professional e-commerce platforms like Shopify and Amazon, including their 'hover-to-zoom' features."
  },
  {
    question: "How does the file and folder management work?",
    answer: "You have full control over your designs. When you create a mockup, you can save it directly to a folder you've created. You can access all your past mockups in your Account page, where you can create new folders, rename them, and move your mockups between them for easy organization."
  }
];

// Reusable component for a single FAQ item
const FaqItem = ({ item, index, isOpen, onToggle }) => {
  return (
    // Added logic: if isOpen is true, add the 'active' class
    <div className={`faq-item ${isOpen ? 'active' : ''}`}>
      <button 
        className="faq-question" 
        onClick={() => onToggle(index)}
        aria-expanded={isOpen}
      >
        {item.question}
        <span className="faq-icon">{isOpen ? '+' : '+'}</span>
      </button>
      <div className={`faq-answer ${isOpen ? 'open' : ''}`}>
        {item.answer}
      </div>
    </div>
  );
};

// Main page component
const FaqPage = () => {
  const [openIndex, setOpenIndex] = useState(null); 

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-page-container">
      <h1 className="faq-title">Frequently Asked Questions</h1>
      <p className="faq-subtitle">
        Have questions about our AI engine, pricing, or file formats? We're here to help.
      </p>
      <div className="faq-list">
        {faqData.map((item, index) => (
          <FaqItem 
            key={index} 
            item={item} 
            index={index}
            isOpen={openIndex === index}
            onToggle={handleToggle}
          />
        ))}
      </div>
    </div>
  );
};

export default FaqPage;